<template>
  <teleport to="body">
    <div ref="toast" class="toast hide position-fixed top-0 start-50 translate-middle-x" v-on:click="hide()">
      <div v-if="!toastData.isSimpleLayout" class="toast-header">
        {{toastData.title}}
      </div>
      <div class="toast-body">
        {{toastData.body}}
      </div>
    </div>
  </teleport>
</template>

<script>
  import { defineComponent } from "vue";
  import { Toast } from "bootstrap";
  import { jsonTryParse } from "utils/json";

  export default defineComponent({
    props: {
      storedDataPrefix: {
        type: String,
        default: null,
      },
    },
    data: () => {
      return {
        toastData: {
          title: null,
          body: null,
          isSimpleLayout: false,
          includeNotifications: false,
        },
        storedData: {
          title: null,
          body: null,
          isSimpleLayout: false,
          includeNotifications: false,
          effectiveDate: null,
        },
        bsToast: null,
      }
    },
    methods: {
      createToast({ title = "", body = "", isSimpleLayout = false, includeNotifications = false }) {
        this.toastData.title = title;
        this.toastData.body = body;
        this.toastData.isSimpleLayout = title ? isSimpleLayout : true;
        if (!this.bsToast) this.bsToast = new Toast(this.$refs.toast);
      },
      storeToast({ title = "", body = "", isSimpleLayout = false, includeNotifications = false, prefix = null }) {
        this.storedData.title = title;
        this.storedData.body = body;
        this.storedData.isSimpleLayout = title ? isSimpleLayout : true;
        let effectiveDate = new Date();
        effectiveDate.setMinutes(effectiveDate.getMinutes() + 1);
        this.storedData.effectiveDate = effectiveDate;

        sessionStorage.setItem(prefix != null ? `__manabibako__toast__store__${prefix}` : "__manabibako__toast__store", JSON.stringify(this.storedData));
      },
      restoreToast() {
        let storedStrVal = sessionStorage.getItem(this.storedDataPrefix != null ? `__manabibako__toast__store__${this.storedDataPrefix}` : "__manabibako__toast__store");
        sessionStorage.removeItem(this.storedDataPrefix != null ? `__manabibako__toast__store__${this.storedDataPrefix}` : "__manabibako__toast__store");
        if (storedStrVal == null) {
          return;
        }
        let storedJson = jsonTryParse(storedStrVal);
        if (storedJson == null) {
          return;
        }
        if (storedJson.effectiveDate != null && new Date(storedJson.effectiveDate).valueOf() < new Date().valueOf()) {
          return;
        }
        this.createToast({
          title: storedJson.title,
          body: storedJson.body,
          isSimpleLayout: storedJson.isSimpleLayout,
          includeNotifications: storedJson.includeNotifications,
        });
        this.show();
      },
      show(autoHide = true) {
        this.$refs.toast.dataset.bsAutohide = autoHide;
        this.bsToast.show();
      },
      hide() {
        this.bsToast.hide();
      },
    },
    mounted() {
      this.restoreToast();
    },
  });
</script>
